import React, { useEffect } from 'react';

import { useNavigate } from 'react-router';

import { setNavigate } from '../../helpers/navigation';

/**
 * Компонент-утилита для извлечения функции навигации из хука `useNavigate`
 * и сохранения её во внешнем хелпере, чтобы управлять текущим адресом
 * за пределами React-дерева (например, в Redux-сагах или сервисах).
 *
 * Причина существования: `BrowserRouter` v7 не принимает проп `history`,
 * а `HistoryRouter` пока нестабилен. Когда `HistoryRouter` станет стабильным,
 * этот компонент можно будет удалить и перейти на него.
 *
 * @see https://reactrouter.com/en/main/routers/history-router
 */
export const InitNavigate = () => {
    const navigate = useNavigate();
    useEffect(() => {
        setNavigate(navigate);
    }, [navigate]);
    return <></>;
};
